/**
 * Strips HTML tags from a string, preserving the text content.
 * 
 * @param html - The HTML string to strip tags from
 * @returns Plain text without HTML tags
 */
export function stripHtmlTags(html: string): string {
  if (!html) return '';
  
  // Create a temporary DOM element
  const tempDiv = document.createElement('div');
  
  // Set the HTML content
  tempDiv.innerHTML = html;
  
  // Get the text content (this preserves spacing and line breaks better than regex)
  const textContent = tempDiv.textContent || tempDiv.innerText || '';
  
  // Return the text content with normalized whitespace
  return textContent.trim();
}